import { BillingWorkspace } from '@/components/billing/billing-workspace'

export function CommitteeBilling() {
  return <BillingWorkspace basePath="/committee/billing" />
}
